import { render, staticRenderFns } from "./SendPayment.vue?vue&type=template&id=541b5ada&"
import script from "./SendPayment.vue?vue&type=script&lang=ts&"
export * from "./SendPayment.vue?vue&type=script&lang=ts&"
import style0 from "./SendPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports